var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrestling({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EB5556",
    fillRule: "nonzero",
    d: "M10.52 0c1.463 4.132 3.29 6.006 5.435 6.006 2.103 0 3.753-1.833 4.91-5.945l2.792.461-.39 7.244-.017.32-.152.281c-4.69 8.644-9.854 8.036-14.28.008l-.133-.24-.034-.272-.885-7.216 2.755-.647Zm11.715.446c-1.31 4.655-3.403 6.982-6.28 6.982-2.876 0-5.135-2.318-6.776-6.954l.885 7.216c3.517 6.377 7.326 8.214 11.782 0l.39-7.244Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB5556",
    d: "M21.377.191c1.3-.22 2.691-.06 3.999.663-1.418 8.547.486 14.685 6.017 18.193-7.23 11.736 0 18.05-1.019 30.953l-12.302 0-.006-1.083c-.077-6.52-.867-10.056-2.369-10.608-1.585.582-2.376 4.479-2.376 11.691l-12.302 0c-1.019-12.903 6.21-19.217-1.019-30.953 5.531-3.508 7.435-9.646 6.017-18.193 1.308-.722 2.7-.883 4-.663-.026 5.936.243 11.513 5.69 11.513 5.447 0 5.695-5.577 5.67-11.513Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M22.487.1c.963.005 1.948.234 2.889.754-1.418 8.547.486 14.685 6.017 18.193-7.23 11.736 0 18.05-1.019 30.953-3.115 0-5.452 0-7.01 0 0-2.402 0-8.782 0-12.04 0-3.26-.484-4.654 2.012-17.075-4.212-9.047-3.488-14.396-2.889-20.785Z",
    opacity: 0.301
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7.78 24.34c.895 3.391.95 6.286.595 13.24-.09 1.755-.128 2.592-.16 3.593-.03.961-.043 1.836-.037 2.667l.001.19 5.391 0c-.066.656-.12 1.367-.16 2.134l-12.467 0c.029-.73.08-1.44.15-2.132l4.951 0c-.01-.913.004-1.871.037-2.927.033-1.019.072-1.865.162-3.634.342-6.722.29-9.489-.528-12.587-.738-2.797-2.106-5.047-4.318-6.841.565-.46 1.082-.955 1.551-1.484 2.447 2.053 4.002 4.634 4.832 7.781Zm22.314-6.218-.256.217c-2.005 1.745-3.267 3.9-3.965 6.545-.818 3.098-.87 5.865-.528 12.587.09 1.769.13 2.615.162 3.634.033 1.056.047 2.014.037 2.927l4.756 0c.07.691.121 1.401.15 2.132l-12.468 0c-.04-.767-.093-1.478-.16-2.134l5.586 0 .002-.19c.006-.83-.007-1.706-.037-2.667-.032-1.001-.07-1.838-.16-3.593-.354-6.954-.3-9.849.595-13.24.818-3.099 2.338-5.65 4.72-7.688.475.525.997 1.015 1.566 1.47Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrestling);
export default __webpack_public_path__ + "static/media/wrestling.2c1ec8f58e2cfa62c54934794b874d3f.svg";
export { ForwardRef as ReactComponent };